import firebase from '../plugins/firebase';
import CryptoJS from 'crypto-js';

const db = firebase.firestore();

export default class DashboardService {
  constructor({ universeId, userEmail }) {
    this.universeId = universeId;
    this.userEmail = userEmail;

    try {
      this.login();
    } catch {}
  }

  async login() {
    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

    const password = CryptoJS.HmacSHA1(this.userEmail, process.env.VUE_APP_STUDIO_FIREBASE_AUTH_CRIPTO_KEY).toString();

    try {
      await firebase.auth().signInWithEmailAndPassword(this.userEmail, password);
    } catch {
      await firebase.auth().createUserWithEmailAndPassword(this.userEmail, password);
    }
  }

  async getDashboard() {
    const dashboards = await db
      .collection('universes')
      .doc(this.universeId)
      .collection('dashboards')
      .where('users', 'array-contains', this.userEmail)
      .get();

    return (dashboards.docs || [])[0];
  }
}
